<article
  class="ab-card relative h-64 rounded-2xl overflow-hidden shadow-lg group transition-padding duration-300
  bg-gradient-{{ border() }} bg-gradient-{{ border() }}--animated-bg"
>
  <div
    class="absolute top-0 left-0 inset-0 group-hover:m-2 transition-all rounded-xl"
    style="
    background-image: url('{{ item().image }}');
    background-size: cover;
    background-position: center;
  "
  ></div>
  <!-- Overlay -->
  <div
    class="absolute top-0 left-0 inset-0 bg-black bg-opacity-50 group-hover:bg-opacity-60 group-hover:m-2 transition-all rounded-xl"
  ></div>

  <!-- Texto -->
  <div
    class="absolute top-0 left-0 inset-0 flex flex-col items-center justify-center text-white p-6 group-hover:m-2 group-hover:p-4"
  >
    <h3 class="text-xl font-semibold mb-2">{{ item().title }}</h3>
    <p class="text-sm">{{ item().description }}</p>
  </div>
</article>
